import React, { useEffect } from "react";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function CompletionOfFlight({ templateName }: { templateName: string }) {
    const user = useAppSelector(getUser)
    const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
    const [firstLastName, setFirstLastName] = React.useState("")
    const [grade, setGrade] = React.useState("")
    const [date, setDate] = React.useState("")
    const dispatch = useDispatch()
    useEffect(() => {
        const templateText = `I certified that ${name} [First name, MI, Last name], ${firstLastName} [grade of pilot certificate], ${grade} has satisfactorily completed a flight review of §61.56(a), on ${date}`
        dispatch(setTemplateText(templateText))
    }, [name, grade, date, dispatch])
    return (
        <TemplateLayout templateName={templateName}>
            <div className="col-12 my-2">
                <label>Relevant FAR: 61.189(2)</label>
            </div>

            <div className="col-12 my-2">
                <p className="certificate_text">
                    I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> [First name, MI, Last name], <input type="text" onChange={(e) => setFirstLastName(e.target.value)} /> [grade of pilot certificate], <input type="text" onChange={(e) => setGrade(e.target.value)} /> has satisfactorily completed a flight review of §61.56(a), on <input type="date" onChange={(e) => setDate(e.target.value)} />
                </p>
            </div>
        </TemplateLayout>
    );
}

export default CompletionOfFlight;
